import type { ReactElement } from 'react';

import { ensureDefined } from '@e-socna/utils';
import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import { wrapExpression } from '../../../utils/handlebars-expression.util';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useMissionQuickAccess } from './hooks/useMissionQuickAccess.hook';

export const useDevisLieuDate = (
  parameters: ResolverParameters,
): ResolverResult<ReactElement> => {
  const quickAccess = useMissionQuickAccess(parameters);

  if (!quickAccess.isSuccess) {
    return {
      ...quickAccess,
      data: undefined,
    };
  }

  const {
    data: {
      consolidation: {
        quotationEmitterActor: {
          thirdParty: { billingAddress },
        },
      },
    },
  } = ensureDefined({
    data: quickAccess.data,
  });

  if (!billingAddress?.postalInfo?.locality) {
    return {
      data: undefined,
      error: new Error('Adresse de facturation manquante'),
      isSuccess: false,
      isLoading: false,
    };
  }

  const {
    postalInfo: { locality },
  } = billingAddress;

  return {
    data: {
      generated: (
        <div className={RESOLVER_CONTENT_CLASSNAME}>
          {locality}, le {wrapExpression('DateCourante')}
        </div>
      ),
    },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
